import service from "../../images/decor.png"
import React from 'react'

const ServiceDecor = () => {
    return (
        <>
            <div className='container'>
                <h6 className='service-head '> ALL SERVICES</h6>
                <div className='row'>
                    <div className='col-lg-5'>
                        <img src={service} height={300} className='w-100 br-20' alt={service} />
                        <h3 className='color-primary  text-center mt-2'>Interior Decor</h3>
                    </div>
                    <div className='col-lg-7 mt-5 mb-5'>
                        <h3>Elevate Your Space with Inspired Interior Design</h3>
                        <p>At AFS DOTE, we believe your space should reflect your personality, enhance your lifestyle, and inspire daily living. Our expert interior designers blend creativity with functionality to craft environments that are both beautiful and practical.</p>
                        <p>Whether you're redesigning a single room or transforming an entire home, we offer:</p>
                        <ul>
                            <li>Custom Residential Interiors – Tailored to your taste and needs.</li>
                            <li>Commercial Spaces – Stylish, functional designs that impress and perform.</li>
                            <li>Space Planning & Layout Optimization – Maximizing flow and efficiency.</li>
                            <li>Color, Lighting & Material Selection – Thoughtfully curated elements for a cohesive look.</li>
                            <li>Color Consultation & Material Selection – Creating cohesive, timeless palettes.</li>
                            <li>Furniture & Décor Curation – Sourcing unique pieces to complete your vision.</li>
                            <p>Let us turn your space into a masterpiece that feels like home.</p>
                            </ul>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ServiceDecor
